import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import { get_preview_details, open_preview as open_file_preview } from "@/utils/file_preview";
import { view_profile as view_profile_helper } from "@/views/home/home_helper.js";
const GLOBAL_URL = process.env.VUE_APP_BACKEND_API_URL;
const VIDEO_MEDIA_PATTERN = /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i;

export default {

    name: "ReportCommentModal",

    props: {
        title: {
            type: String,
            default: "Modal Title",
        },
        report_data: {
            type: Map,
        },
        portal_admin: {
            type: Boolean,
            default: false,
          },
        },

    data() {
        var data = {
            headers: {},
            comments_data: {},
            editing_reply_id: null,
            editing_reply_text: "",
            expandedReports: [],
            expandedReportsComments: [],
            expandedHubComments: [],
            editing_comment_id: null,
            editing_comment_text: "",
            user_id:null,
            isZoomed: false,
            isFullscreen: false,
            comment_count: 0,
            token_exists: false,
            user_details: {
                "user_role": '',
                "first_name": '',
                "last_name": '',
            },
            commentText: '',
            replyTexts: {},
            showReplyInput: {},
            visible_replies_map: {},
            preview_url: null,
            preview_type: null,
            preview_file_name: '',
            loading_preview: false,
            users: [],
            showSuggestions: false,
            currentTagPosition: null,
            filteredUsers: [],
            isLoading:false,
            create_timeline_api_url: `${GLOBAL_URL}/portal_management/create_report_timeline_api/`,
            get_timeline_api_url: `${GLOBAL_URL}/portal_management/get_report_timelines_api/`,
            active_comment_tab: 'timeline',
            timeline_updates: [],
            editing_timeline_update_id: null,
            timeline_panel_visible: false,
            timeline_form: {
                title: '',
                date: '',
                description: '',
                images: [],
            },
            timeline_errors: {},
        };

        return data;
    },

    async mounted() {
        this.user_id = this.get_user_id();

        this.headers = {
            'Content-Type': 'application/json',
            Authorization: `Token ${get_token()}`
        };

        this.comments_data = this.report_data.comments || [];
        this.timeline_updates = this.get_report_timeline_updates();
        this.fetch_timeline_updates();

        
        if(this.report_data && this.report_data.report_link){
            this.fetchReportPreview(this.report_data);
        }
        else{
            this.show_modal();
        }
        // this.get_comments(1);
        this.token_exists = get_token();
        this.user_details=get_user_details();
        this.fetch_users();
    },


    methods: {
        toggleZoom() {
            this.isZoomed = !this.isZoomed;
          },
          toggleFullscreen() {
            const image = this.$refs.image[0];
            
            // Check if fullscreen is already active
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
              // Request fullscreen for the image element (using the correct method for various browsers)
              if (image.requestFullscreen) {
                image.requestFullscreen();
              } else if (image.mozRequestFullScreen) { /* Firefox */
                image.mozRequestFullScreen();
              } else if (image.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                image.webkitRequestFullscreen();
              } else if (image.msRequestFullscreen) { /* IE/Edge */
                image.msRequestFullscreen();
              }
            } else {
              // Exit fullscreen
              if (document.exitFullscreen) {
                document.exitFullscreen();
              } else if (document.mozCancelFullScreen) { /* Firefox */
                document.mozCancelFullScreen();
              } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                document.webkitExitFullscreen();
              } else if (document.msExitFullscreen) { /* IE/Edge */
                document.msExitFullscreen();
              }
            }
          },

            open_preview(document) {
              const file_name = get_preview_details(document);
              this.preview_file_name = file_name || 'File';
              open_file_preview(this, document, "report_preview_modal");
              this.loading_preview = this.preview_type !== "other";
            },

            on_content_loaded() {
              this.loading_preview = false;
            },


        get_user_id() {
            const user_id = localStorage.getItem('user_id') || '';
            return user_id;
        },

        set_comment_tab(tab_name) {
            this.active_comment_tab = tab_name;
        },

        can_manage_report_timeline() {
            if (!this.token_exists) return false;
            return this.is_report_admin() || this.is_report_creator();
        },

        is_report_admin() {
            return this.portal_admin || this.user_details?.user_role === 'admin';
        },

        is_report_creator() {
            const logged_in_user_id = String(this.user_id || this.user_details?.user_id || this.user_details?.id || '');
            if (!logged_in_user_id) return false;

            const report = this.report_data || {};
            const creator_ids = [

                report?.base_profile?.user?.id,
                report?.base_profile?.creater?.id,
            ].filter((id) => id !== undefined && id !== null);

            return creator_ids.some((id) => String(id) === logged_in_user_id);
        },

        get_report_timeline_updates() {
            const timeline_sources = [
                this.report_data?.timeline_updates,
                this.report_data?.timeline,
                this.report_data?.journey_timeline,
                this.report_data?.report_timeline,
            ];

            const source = timeline_sources.find((items) => Array.isArray(items));
            if (source && source.length) {
                return source.map((item) => this.normalize_timeline_update(item));
            }

            return [];
        },

        fetch_timeline_updates() {
            const report_id = this.report_data?.id || this.report_data?.report_id;
            if (!report_id) return;

            $.ajax({
                url: this.get_timeline_api_url,
                method: 'POST',
                headers: this.headers,
                contentType: 'application/json',
                data: JSON.stringify({ report_id }),
                success: (response) => {
                    const updates = response?.data || response?.timeline_updates || response?.timeline || [];
                    if (Array.isArray(updates)) {
                        this.timeline_updates = updates.map((item) => this.normalize_timeline_update(item));
                    }
                }
            });
        },

        first_present_value(values, fallback = '') {
            const value = values.find((item) => item !== undefined && item !== null && item !== '');
            return value === undefined ? fallback : value;
        },

        get_timeline_media_items(item) {
            const media = this.first_present_value([
                item?.images,
                item?.media,
                item?.files,
                item?.timeline_files,
                item?.report_files,
            ], []);

            return Array.isArray(media) ? media : [];
        },

        normalize_timeline_update(item) {
            return ({
                id: this.first_present_value([item?.id, item?.timeline_id], `timeline-${Date.now()}-${Math.random().toString(36).slice(2)}`),
                title: this.first_present_value([item?.title, item?.timeline_title, item?.name], 'Timeline update'),
                date: this.first_present_value([item?.date, item?.timeline_date, item?.created_at, item?.publication_date]),
                description: this.first_present_value([item?.description, item?.timeline_description, item?.comment]),
                images: this.get_timeline_media_items(item).map((image) => this.normalize_timeline_media(image)).filter(Boolean),
            });
        },

        normalize_timeline_media(media) {
            if (!media) return null;
            const url = this.get_timeline_media_url(media);
            if (!url) return null;

            return ({
                name: this.first_present_value([media?.name, media?.file?.name], this.getFileName(url)),
                preview: url,
                type: this.first_present_value([media?.type, media?.media_type], this.get_timeline_media_type(url)),
                existing: this.is_existing_timeline_media(media),
            });
        },

        is_existing_timeline_media(media) {
            return Boolean(media?.existing || typeof media === 'string' || this.get_timeline_media_url(media));
        },

        get_timeline_media_url(media) {
            if (!media) return null;
            if (typeof media === 'string') return media;
            return this.first_present_value([
                media?.preview,
                media?.url,
                media?.file?.url,
                media?.file?.file_url,
                media?.file?.s3_url,
                media?.file_url,
                media?.s3_url,
            ], null);
        },

        get_timeline_media_type(value) {
            const source = typeof value === 'string'
                ? value
                : this.first_present_value([value?.type, value?.preview, value?.url]);

            const lower_source = String(source || '').toLowerCase();

            if (this.is_video_media_source(lower_source)) {
                return 'video';
            }

            const image_checks = [
                lower_source.startsWith('image/'),
                lower_source.startsWith('data:image'),
                /\.(jpe?g|png|gif|webp|avif)(?:$|[?#])/i.test(lower_source),
            ];

            if (image_checks.some(Boolean)) {
                return 'image';
            }

            return get_preview_details({ url: source }).type || 'other';
        },

        is_video_media_source(source) {
            return source === 'video' || source.startsWith('video/') || source.startsWith('data:video') || VIDEO_MEDIA_PATTERN.test(source);
        },

        is_timeline_video(media) {
            return this.get_timeline_media_type(media) === 'video';
        },

        is_timeline_image(media) {
            return this.get_timeline_media_type(media) === 'image';
        },

        get_timeline_media_preview(media) {
            return this.get_timeline_media_url(media);
        },

        get_timeline_media_count(update) {
            return Array.isArray(update?.images) ? update.images.length : 0;
        },

        get_timeline_month(update) {
            const date = this.parse_timeline_date(update?.date);
            if (!date) return update?.date || 'Timeline';
            return date.toLocaleString('en-US', { month: 'long', year: 'numeric' });
        },

        parse_timeline_date(value) {
            if (!value) return null;
            const parsed = new Date(value);
            return Number.isNaN(parsed.getTime()) ? null : parsed;
        },

        sorted_timeline_updates() {
            return [...this.timeline_updates].sort((a, b) => {
                const first = this.parse_timeline_date(a.date)?.getTime() || 0;
                const second = this.parse_timeline_date(b.date)?.getTime() || 0;
                return first - second;
            });
        },

        reset_timeline_form() {
            this.timeline_form = {
                title: '',
                date: new Date().toISOString().slice(0, 7),
                description: '',
                images: [],
            };
            this.timeline_errors = {};
            this.editing_timeline_update_id = null;
        },

        open_add_timeline_modal() {
            if (!this.can_manage_report_timeline()) {
                return;
            }

            this.reset_timeline_form();
            this.active_comment_tab = 'timeline';
            this.timeline_panel_visible = true;
        },

        open_edit_timeline_modal(update) {
            if (!this.can_manage_report_timeline()) {
                return;
            }

            this.editing_timeline_update_id = update.id;
            this.timeline_form = {
                title: update.title || '',
                date: this.to_timeline_input_date(update.date),
                description: update.description || '',
                images: (update.images || []).map((media) => this.normalize_timeline_media(media)).filter(Boolean),
            };
            this.timeline_errors = {};
            this.active_comment_tab = 'timeline';
            this.timeline_panel_visible = true;
        },

        to_timeline_input_date(value) {
            const date = this.parse_timeline_date(value);
            return date ? date.toISOString().slice(0, 7) : new Date().toISOString().slice(0, 7);
        },

        close_timeline_modal() {
            this.timeline_panel_visible = false;
        },

        handle_timeline_images(event) {
            const files = Array.from(event?.target?.files || []);
            const remaining_slots = Math.max(0, 20 - this.timeline_form.images.length);
            files.slice(0, remaining_slots).forEach((file) => {
                const reader = new FileReader();
                reader.onload = (reader_event) => {
                    this.timeline_form.images.push({
                        name: file.name,
                        file: file,
                        preview: reader_event.target.result,
                        type: this.get_timeline_media_type(file.type || file.name),
                    });
                };
                reader.readAsDataURL(file);
            });
            event.target.value = "";
        },

        remove_timeline_image(index) {
            this.timeline_form.images.splice(index, 1);
        },

        get_safe_comment_key(comment_id) {
            return String(comment_id).replace(/[^\w-]/g, '');
        },

        clone_with_reflected_value(source, key, value) {
            const nextState = { ...source };
            Reflect.set(nextState, key, value);
            return nextState;
        },

        validate_timeline_form() {
            const errors = {};
            if (!String(this.timeline_form.title || '').trim()) errors.title = 'Timeline title is required.';
            if (!String(this.timeline_form.date || '').trim()) errors.date = 'Timeline date is required.';
            if (!String(this.timeline_form.description || '').trim()) errors.description = 'Description is required.';
            this.timeline_errors = errors;
            return Object.keys(errors).length === 0;
        },

        build_timeline_form_data() {
            const form_data = new FormData();
            form_data.append('report_id', this.report_data.id);
            form_data.append('title', String(this.timeline_form.title || '').trim());
            form_data.append('timeline_date', this.timeline_form.date);
            form_data.append('description', String(this.timeline_form.description || '').trim());

            if (this.editing_timeline_update_id) {
                form_data.append('timeline_id', this.editing_timeline_update_id);
            }

            this.timeline_form.images.forEach((media) => {
                if (media?.file) {
                    form_data.append('file', media.file);
                }
            });

            return form_data;
        },

        get_timeline_update_from_response(response, fallback_update) {
            const update = response?.data || response?.timeline_update || response?.timeline_data;
            return this.normalize_timeline_update(update || fallback_update);
        },

        upsert_timeline_update(update) {
            const existing_index = this.timeline_updates.findIndex((item) => String(item.id) === String(update.id));
            if (existing_index >= 0) {
                this.timeline_updates.splice(existing_index, 1, update);
            } else {
                this.timeline_updates.unshift(update);
            }

            this.report_data.timeline_updates = this.timeline_updates;
            this.report_data.timeline = this.timeline_updates;
            this.active_comment_tab = 'timeline';
            this.close_timeline_modal();
        },

        save_timeline_update() {
            if (!this.validate_timeline_form()) return;

            const form_images = this.timeline_form.images
                .map((media) => this.normalize_timeline_media(media))
                .filter(Boolean);
            const timeline_update = {
                id: this.editing_timeline_update_id || `local-timeline-${Date.now()}`,
                title: String(this.timeline_form.title || '').trim(),
                date: this.timeline_form.date,
                description: String(this.timeline_form.description || '').trim(),
                images: form_images,
            };

            $.ajax({
                url: this.create_timeline_api_url,
                method: 'POST',
                headers: { Authorization: `Token ${this.getToken()}` },
                data: this.build_timeline_form_data(),
                processData: false,
                contentType: false,
                success: (response) => {
                    this.upsert_timeline_update(this.get_timeline_update_from_response(response, timeline_update));
                },
                error: (response) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not save timeline',
                        text: response?.responseJSON?.error || 'Please try again.',
                        showConfirmButton: false,
                        timer: 2500,
                        position: 'bottom-end',
                        toast: true
                    });
                }
            });
        },

        getToken() {
            return get_token();
        },
        show_modal() {

            $("#comment_modal").modal("show");
        },

        hide_modal() {
            this.timeline_panel_visible = false;
            $("#comment_modal").modal("hide");
            this.$emit('hide_comment_comment')
            const baseUrl = ``;
            this.$router.replace({ path: baseUrl });
        },

        async get_comments(page_number) {

            var request_data = {
                "report_id": this.report_data.id,
                "page_number": page_number,
            }

            var request_url = `${GLOBAL_URL}/portal_management/retrieve_report_comments/`;

            $.ajax({
                url: request_url,
                method: 'GET',
                headers: this.headers,
                data: request_data,
                success: (response) => {

                    if (response.status === "success") {
                        var response_data = response.data;
                        this.comments_data = response_data.comments_data.queryset;

                        this.comment_count = response_data.comments_data.count;
                    }

                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        },
        edit_comment(comment_data) {
            this.editing_comment_id = comment_data.id;
            this.editing_comment_text = comment_data.comment_text;
            
        },
         fetchReportPreview(report) {
              $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
                type: 'POST',
                data: { url: report.report_link },
                headers: { Authorization: `Token ${get_token()}` },
                success: (data) => { report.linkPreview = data;
                   },
                complete: () => {
                    this.show_modal(); 
                }
              });
            },
        save_edit_comment(comment_id) {
    
            const data = {
                report_comment_id: comment_id,
                comment_text: this.editing_comment_text
            };
            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/edit_report_comment/`,
                headers: this.headers,
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: (response) => {
                    if (response.status === "success") {
                        const comment = this.comments_data.find(comment => comment.id === comment_id);
                        comment.comment_text = this.editing_comment_text;
                        this.editing_comment_id = null;
                        this.editing_comment_text = "";
                    } 
                },
                error: (response) => {
                    const response_status =response.responseJSON
                    if(response_status.status === "error"){
                    Swal.fire({
                        icon: 'error',
                        title: 'Unauthorized Accesss',
                        showConfirmButton: false,
                        timer: 2000,
                        position: 'bottom-end',
                        toast: true
                    });
                    }
                }
            });
        },
        delete_comment(report_comment_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes,delete it',
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        type: "DELETE",
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_comment/`,
                        data: JSON.stringify({ report_comment_id: report_comment_id }),
                        contentType: 'application/json',
                        headers: this.headers,
                        success: (response) => {
                            if (response.status === "success") {
                                Swal.fire({
                                    title: 'Deleted!',
                                    text: 'The comment has been deleted.',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1000,
                                    position: 'bottom-end',
                                    toast: true
                                })
                                .then(() => {
                                    this.get_comments(1);
                                    this.report_data.total_comments -= 1;

                                });
                            } else {
                                Swal.fire({
                                  title: 'Failed!',
                                  text: response.message || 'An error occurred. Please try again.',
                                  icon: 'error',
                                  position: 'bottom-end',
                                  showConfirmButton: false,
                                  timer: 3000,
                                  toast: true
                                });
                            }
                        },
                        
                    });
                }
            });
        },

async submit_comment() {
    if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
    }

    const comment_text = String(this.commentText || "").trim();

    if (comment_text === "") {
        Swal.fire({
            icon: 'error',
            title: 'Please write a comment before submitting.',
            timer: 2000,
            showConfirmButton: false,
        });
        return;
    }

    const temp_comment_id = `temp-${Date.now()}`;
    const baseUrl = `${window.location.origin}${this.$route.path}?report_id=${this.report_data.id}`;

    const now = new Date();
    const formattedDate = now.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    // --- Temp comment matching backend structure ---
    const tempComment = {
        id: temp_comment_id,
        base_profile: {
            id: null,
            profile_type: 'personal',
            user: this.user_details || {
                id: null,
                first_name: 'You',
                last_name: '',
                email: '',
                profile: { id: null, profile_files: [] }
            },
            company: null
        },
        comment_text: comment_text,
        time: formattedDate,
        reply_comment: [],
        likes_count: 0,
        likes: [],
        is_loading: true // frontend-only
    };

    this.comments_data.push(tempComment);
    this.commentText = "";

    const request_data = {
        report_id: this.report_data.id,
        comment_text: comment_text,
        base_url: baseUrl
    };

    const request_url = `${GLOBAL_URL}/portal_management/add_report_comment/`;

    $.ajax({
        url: request_url,
        method: 'POST',
        headers: this.headers,
        data: JSON.stringify(request_data),
        success: (response) => {
            if (response.status === "success") {
                const response_data = response.data;

                // replace temp comment with backend comment
                const tempIndex = this.comments_data.findIndex(c => c.id === temp_comment_id);
                if (tempIndex !== -1) {
                    this.comments_data.splice(tempIndex, 1, response_data.comment_data);
                    this.$nextTick(() => {
                        const el = this.$refs[response_data.comment_data.id];
                        if (el && el[0]) {
                            el[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    });
                }

                this.report_data.total_comments += 1;
            }
        },
        error: () => {
            this.comments_data = this.comments_data.filter(c => c.id !== temp_comment_id);
            Swal.fire({
                icon: 'error',
                title: 'Could not add comment',
                text: 'Please try again later.',
                timer: 3000,
                showConfirmButton: false,
                position: 'bottom-end',
                toast: true
            });
        },
        complete: () => {
            this.isSubmitting = false;
        }
    });
},

get_active_profile_picture(item) {
      const base = item?.base_profile || item;
      if (!base) return null;

      if (base.profile_type === 'personal') {
        return this.get_personal_logo(base);
      }

      if (base.profile_type === 'business') {
        return this.get_business_logo(base);
      }

      return null;
    },

    get_personal_logo(base) {
      const files = base.user?.profile?.profile_files;
      if (!files) return null;

      const pic = files.find(f => f.profile_file_type === 'profile_picture');
      return pic?.file?.url || null;
    },

    get_business_logo(base) {
      const files = base.company?.base_profile?.profile_files;
      if (!files) return null;

      const logo = files[0]?.file;
      return logo?.file_url || logo?.url || null;
    },
 
async get_comment_replies(comment_id, page_number) {
    const request_data = {
        "report_comment_id": comment_id,
        "page_number": page_number,
    };

    const request_url = `${GLOBAL_URL}/portal_management/retrieve_report_comment_replies/`;

    $.ajax({
        url: request_url,
        method: 'GET',
        headers: this.headers,
        data: request_data,
        success: (response) => {
            if (response.status === "success") {
                var response_data = response.data;
                var comment_replies = response_data.replies_data.queryset;

                const reply_container = $(`#reply_section_${comment_id}`);
                reply_container.empty();

                const repliesToShow = 2;
                comment_replies.forEach((comment_reply, index) => {
                    var reply_template = $("#reply_template").clone();
                    reply_template.attr("id", `reply_${comment_reply.id}`);

                    // Fill the reply content
                    const reply_time = comment_reply.time;
                    const reply_text = comment_reply.reply;
                    const reply_user = comment_reply.user;

                    const reply_user_id = comment_reply.user.id;
                    const logged_in_user_id = this.user_id;

                    const textLength = reply_text.length;
                    const maxLength = 25;

                    const hasNames = reply_user.first_name && reply_user.last_name;
                    const displayName = hasNames
                        ? `${reply_user.first_name} ${reply_user.last_name}`
                        : reply_user.company_name || "Unknown";

                    // Set name/company and add click handlers
                    if (hasNames) {
                        reply_template.find(".reply_Name")
                            .text(reply_user.first_name)
                            .off('click')
                            .on('click', (e) => {
                                e.stopPropagation();
                                this.view_profile({ user: reply_user });
                            });
                        reply_template.find(".reply_last_name")
                            .text(reply_user.last_name)
                            .off('click')
                            .on('click', (e) => {
                                e.stopPropagation();
                                this.view_profile({ user: reply_user });
                            });
                    } else {
                        reply_template.find(".reply_Name")
                            .text("");
                        reply_template.find(".reply_last_name")
                            .text(displayName)
                            .off('click')
                            .on('click', (e) => {
                                e.stopPropagation();
                                this.view_company({ user: reply_user });
                            });
                    }
                    reply_template.find(".reply_time").text(reply_time);
                                            // Add "Read More" and "Read Less" functionality for individual replies
                    if (textLength > maxLength) {
                        const readMoreTemplate = $("#read_more_template").clone();
                        readMoreTemplate.removeClass("d-none");
                        reply_template.find(".reply_text_container").append(readMoreTemplate);

                        reply_template.find(".comment_text").text(reply_text.substring(0, maxLength) + "...");
                        readMoreTemplate.find('.read-more-button').on('click', function() {
                            reply_template.find(".comment_text").text(reply_text);
                            $(this).addClass('d-none');
                            readMoreTemplate.find('.read-less-button').removeClass('d-none');
                        });

                        readMoreTemplate.find('.read-less-button').on('click', function() {
                            reply_template.find(".comment_text").text(reply_text.substring(0, maxLength) + "...");
                            $(this).addClass('d-none');
                            readMoreTemplate.find('.read-more-button').removeClass('d-none');
                        });
                    } else {
                        reply_template.find(".comment_text").text(reply_text);
                    }

                    // Edit and delete reply actions
                    reply_template.find(".edit_reply").click(() => {
                        reply_template.find(".edit_reply_input").removeClass("d-none");
                        reply_template.find(".edit_reply_text").val(comment_reply.reply);
                        reply_template.find(".save_edit_reply").on("click", () => {
                            var reply_text = reply_template.find(".edit_reply_text").val();
                            let editing_comment_id = comment_reply.id;

                            this.save_edit_reply(editing_comment_id, reply_text);
                            reply_template.find(".comment_text").text(reply_text);
                            reply_template.find(".edit_reply_input").addClass("d-none");
                        });
                    });

                    reply_template.find(".delete_reply").on("click", () => {
                        this.deletereportReply(comment_reply.id);
                    });

                    // Toggle actions based on user id
                    if (String(reply_user_id) === String(logged_in_user_id)) {
                        reply_template.find(".reply_dropdown").removeClass("d-none");
                    } else {
                        reply_template.find(".reply_dropdown").addClass("d-none");
                    }

                    reply_template.removeClass("d-none");

                    if (index < repliesToShow) {
                        reply_template.addClass('show-reply');
                    } else {
                        reply_template.addClass('hidden-reply d-none');
                    }

                    reply_container.append(reply_template);
                });

                // Add "Read More" and "Read Less" functionality for replies
                if (comment_replies.length > repliesToShow) {
                    var read_more_template = $("#read_more_template").clone();
                    read_more_template.removeClass("d-none");

                    read_more_template.find('.read-more-button').on('click', function() {
                        reply_container.find('.hidden-reply').removeClass('d-none');
                        $(this).addClass('d-none');
                        read_more_template.find('.read-less-button').removeClass('d-none');
                    });

                    read_more_template.find('.read-less-button').on('click', function() {
                        reply_container.find('.hidden-reply').addClass('d-none');
                        $(this).addClass('d-none');
                        read_more_template.find('.read-more-button').removeClass('d-none');
                    });

                    reply_container.append(read_more_template);
                }

                reply_container.removeClass("d-none");
                this.toggler_comment_input(comment_id);
            }
        },
        complete: () => {
            this.isLoading = false;
        }
    });
},
        
                
        toggler_comment_input(comment_id) {
            const commentKey = this.get_safe_comment_key(comment_id);
            this.showReplyInput = this.clone_with_reflected_value(
                this.showReplyInput,
                commentKey,
                !Reflect.get(this.showReplyInput, commentKey)
            );
        },

        toggleReplies(comment_id) {
            const commentKey = this.get_safe_comment_key(comment_id);
            this.visible_replies_map = this.clone_with_reflected_value(
                this.visible_replies_map,
                commentKey,
                !Reflect.get(this.visible_replies_map, commentKey)
            );
        },

        is_reply_input_visible(comment_id) {
            return Boolean(Reflect.get(this.showReplyInput, this.get_safe_comment_key(comment_id)));
        },

        are_replies_visible(comment_id) {
            return Boolean(Reflect.get(this.visible_replies_map, this.get_safe_comment_key(comment_id)));
        },

        get_reply_text(comment_id) {
            return Reflect.get(this.replyTexts, this.get_safe_comment_key(comment_id)) || "";
        },

        set_reply_text(comment_id, reply_text) {
            const commentKey = this.get_safe_comment_key(comment_id);
            this.replyTexts = this.clone_with_reflected_value(this.replyTexts, commentKey, reply_text);
        },

        addReplyToComment(comment_id, reply_data) {
    if (!reply_data) return;

    const comment = (this.report_data.comments || []).find(c => String(c.id) === String(comment_id));
    if (!comment) return;

    if (!Array.isArray(comment.reply_comment)) comment.reply_comment = [];

    comment.reply_comment.push(reply_data);
    this.visible_replies_map = this.clone_with_reflected_value(
        this.visible_replies_map,
        this.get_safe_comment_key(comment_id),
        true
    );
  },

  updateUIWithReply(comment_id, reply_data) {
    const reply_template = $("#reply_template").clone();

    reply_template.find(".comment_text").text(reply_data.reply || "");
    reply_template.find(".reply_time").text(reply_data.time || "");
    reply_template.find(".reply_Name").text(reply_data?.base_profile?.creater?.first_name || "Unknown");

    const reply_section = $(`#reply_section_${comment_id}`);
    reply_section.append(reply_template);
    reply_section.removeClass("d-none");
    reply_template.removeClass("d-none");
  },

submit_reply(comment_id) {
    if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
    }

    const reply_text_value = String(this.get_reply_text(comment_id)).trim();

    if (reply_text_value === "") {
        Swal.fire({
            icon: "error",
            title: "Can't submit an empty reply.",
            timer: 2000,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
        });
        return;
    }

    const request_data = {
        reply_text: reply_text_value,
        report_comment_id: comment_id,
    };

    const request_url = `${GLOBAL_URL}/portal_management/add_report_comment_reply/`;

    $.ajax({
        url: request_url,
        method: 'POST',
        headers: this.headers,
        data: JSON.stringify(request_data),
        success: (response) => {
  if (response.status !== "success") return;

  const reply_data = response.data?.comment_data || response.data?.reply_data || response.comment_data;

  this.addReplyToComment(comment_id, reply_data);

  const commentKey = this.get_safe_comment_key(comment_id);
  this.replyTexts = this.clone_with_reflected_value(this.replyTexts, commentKey, "");
  this.showReplyInput = this.clone_with_reflected_value(this.showReplyInput, commentKey, false);
},
        complete: () => {
            this.isLoading = false;
        }
    });
},
        readMore(commentsId) {
            const index = this.expandedReportsComments.indexOf(commentsId);
            if (index === -1) {
              this.expandedReportsComments.push(commentsId);
            } else {
              this.expandedReportsComments.splice(index, 1);
            }
          },
          toggleReadMore(reportId) {
            const index = this.expandedReports.indexOf(reportId);
            if (index === -1) {
              this.expandedReports.push(reportId);
            } else {
              this.expandedReports.splice(index, 1);
            }
          },
        reply_edit(reply) {
            this.editing_comment_id = reply.id;
            this.editing_comment_text = reply.reply;

            $(`#edit_reply_text_area_${reply.id}`).val(this.editing_comment_text);
            $(`#edit_reply_section_${reply.id}`).removeClass("d-none");
            $('#edit_reply_modal').modal('show');
        },

        save_edit_reply(reply_id,reply_text) {
            const request_data = { reply_id: reply_id, reply_text: reply_text };
            const request_url = `${GLOBAL_URL}/portal_management/edit_report_comment_reply/`;

            $.ajax({
                url: request_url,
                method: 'PUT',
                headers: this.headers,
                data: JSON.stringify(request_data),
                contentType: 'application/json',
                success: (response) => {
                    const updatedReply = response.data.reply_data;
                    if (Array.isArray(this.comments_data)) {
                        const comment = this.comments_data.find(comment =>
                            Array.isArray(comment.replies) && comment.replies.some(reply => reply.id === updatedReply.id)
                            );

                        if (comment) {
                            const reply = comment.replies.find(reply => reply.id === updatedReply.id);
                            if (reply) {
                                reply.reply_text = updatedReply.reply_text;
                                $(`#reply_text_${reply.id}`).text(updatedReply.reply_text);
                                }
                            }
                        }
                    $(`#edit_reply_section_${reply_id}`).addClass("d-none");
                    $(`#edit_reply_text_area_${reply_id}`).val('');
                    $("#edit_reply_modal").modal("hide");
                    }
                });
            },
            deletereportReply(reply_id) {
                Swal.fire({
                  title: 'Are you sure?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, delete it!',
                  position: 'bottom-end',
                  toast: true
                }).then((result) => {
                  if (result.isConfirmed) {
                    $.ajax({
                      type: "DELETE",
                      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_comment_reply/`,
                      data: JSON.stringify({ reply_id: reply_id }),
                      headers: {
                        'Authorization': `Token ${this.getToken()}`,
                        'Content-Type': 'application/json'
                      },
                      success: (response) => {
                        const status = response.status;
                        if (status === "success") {
                          Swal.fire({
                            title: 'Deleted!',
                            text: 'The reply has been deleted.',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                          }).then(() => {
                            $(`#reply_${reply_id}`).remove();
                        });
                        } else {
                          Swal.fire({
                            title: 'Failed!',
                            text: response.message || 'An error occurred. Please try again.',
                            icon: 'error',
                            position: 'bottom-end',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true
                          });
                        }
                      },
                      error: () => {
                        Swal.fire({
                          title: 'Failed!',
                          text: 'An error occurred. Please try again.',
                          icon: 'error',
                          position: 'bottom-end',
                          showConfirmButton: false,
                          timer: 3000,
                          toast: true
                        });
                      }
                    });
                  }
                });
              },
              fetch_users() {
                return new Promise((resolve) => {
          
                  const groupId = this.$route.params.group_id;
                $.ajax({
                  type: 'GET',
                  data:{group_id:groupId},
                  url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
                  headers: {
                    'Authorization': `Token ${this.getToken()}`,
                  },
                  success: (response) => {
                    this.users = response.data.users_list;
                    resolve();
                  },
                });
              });
              },
            handleInput(e) {
                const text = e.target.value;
                const lastAtSymbol = text.lastIndexOf('@');

                if (lastAtSymbol !== -1) {
                    const query = text.slice(lastAtSymbol + 1);
                    this.currentTagPosition = lastAtSymbol;
                    this.showSuggestions = true;
                    this.filterUsers(query);
                } else {
                    this.showSuggestions = false;
                }
            },
            filterUsers(query) {
                if (!query) {
                    this.filteredUsers = this.users;
                    return;
                }
                this.filteredUsers = this.users.filter(user => {
                    const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
                    return fullName.includes(query.toLowerCase());
                });
            },
            selectUser(user) {
                const beforeTag = this.commentText.slice(0, this.currentTagPosition);
                this.commentText = `${beforeTag}@${user.first_name}_${user.last_name} `;
                this.$nextTick(() => {
                    this.showSuggestions = false;
                  });            
                },

                view_profile(comment){
                 view_profile_helper(this.$router, comment.user);
                },

                view_company(comment){
                view_profile_helper(this.$router, comment.user?.base_profile || comment.user);

            },
            getFileIcon(fileUrl) {
                const url = fileUrl || ''; // default to empty string if undefined or null

                if (url.includes('.pdf'))
                    return 'https://cdn-icons-png.flaticon.com/128/337/337946.png'; // PDF icon
                if (url.includes('.doc') || url.includes('.docx'))
                    return 'https://cdn-icons-png.flaticon.com/128/337/337932.png'; // Word icon
                if (url.includes('.xls') || url.includes('.xlsx'))
                    return 'https://cdn-icons-png.flaticon.com/128/337/337958.png'; // Excel icon
                if (url.includes('.ppt') || url.includes('.pptx'))
                    return 'https://cdn-icons-png.flaticon.com/128/337/337950.png'; // PowerPoint icon

                return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
                },
                getFileName(fileUrl) {
                const decodedUrl = decodeURIComponent(fileUrl);
                const cleanUrl = decodedUrl.split('?')[0];
                return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
                },
            get_report_images(report) {
                const imageExtensions = [ '.jpg', '.jpeg', '.png', '.avif', '.webp']

                return (report?.report_files || [])
                    .filter(fileObj => {
                        const url = fileObj?.file?.url
                        if (!url) return false
                        if (url.startsWith('data:image')) return true
                        const lowerUrl = url.toLowerCase()
                        return imageExtensions.some(ext => lowerUrl.includes(ext))
                    })
                    .map(fileObj => fileObj.file.url)
            },
            filtered_files(files) {
                if (!files) return []
                return files.filter(fileObj => {
                const url = fileObj?.file?.url || ''
                return !(
                    url.includes('.jpg') ||
                    url.includes('.JPG') ||
                    url.includes('.jpeg') ||
                    url.includes('.JPEG') ||
                    url.includes('.png') ||
                    url.includes('.PNG') ||
                    url.includes('.webp') ||
                    url.includes('.WEBP') ||
                    url.includes('.avif') ||
                    url.includes('.AVIF') ||
                    url.startsWith('data:image')
                )
                })
            },
        }
    }
